import { useMutation } from "@tanstack/react-query";
import { deleteProfileAvatar } from "PFCore/services/profile";
import { Id } from "PFTypes";

export const useProfileAvatarDelete = () =>
  useMutation({
    mutationFn: (profileId: Id) => deleteProfileAvatar(profileId)
  });
